export default function WiFiSignalOff() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="18"
      fill="none"
      viewBox="0 0 24 18"
    >
      <g id="wifi-offline 1" clipPath="url(#clip0_57_207)">
        <g id="Layer_1-2">
          <path
            id="Vector"
            fill="#999"
            d="m9.438 1.312.1 1.828a16.03 16.03 0 0 0-7.39 3.342.203.203 0 0 1-.284-.029L.96 5.366s-.029-.042-.036-.07c-.007-.03-.014-.05-.007-.079 0-.028.007-.05.021-.078a.4.4 0 0 1 .05-.064 17.8 17.8 0 0 1 8.449-3.762m10.013 8.747a.197.197 0 0 0 .284-.028l.918-1.088a.197.197 0 0 0-.029-.285 12.97 12.97 0 0 0-5.753-2.745l-.1 1.849c1.75.391 3.35 1.188 4.68 2.297M3.99 8.66a.2.2 0 0 0-.071.134c0 .057.014.107.05.15l.917 1.088c.071.085.2.1.285.028a11.2 11.2 0 0 1 4.636-2.283l-.1-1.849a12.85 12.85 0 0 0-5.703 2.738zm2.98 3.562a.18.18 0 0 0-.064.135c0 .05.014.107.05.15l.917 1.088c.071.085.206.1.292.02a6.2 6.2 0 0 1 1.898-1.151l-.106-1.892a8.05 8.05 0 0 0-2.98 1.643zm9.487 1.394a.21.21 0 0 0 .291-.021l.918-1.088a.2.2 0 0 0-.022-.285 8.1 8.1 0 0 0-3.03-1.657l-.106 1.892c.726.27 1.38.668 1.949 1.166zM23.59 5.13a17.8 17.8 0 0 0-8.463-3.812l-.1 1.828a16 16 0 0 1 7.396 3.385.203.203 0 0 0 .285-.029l.917-1.088a.197.197 0 0 0-.028-.284zm-10.156 9.935c-.057-.057-.114-.1-.17-.143a1.6 1.6 0 0 0-.975-.334 1.6 1.6 0 0 0-.974.334c-.057.043-.12.086-.17.143a1.63 1.63 0 0 0-.477 1.152 1.625 1.625 0 0 0 1.628 1.628 1.625 1.625 0 0 0 1.629-1.628c0-.434-.17-.847-.477-1.152zM13.754.75H10.81c-.064 0-.114.057-.114.12l.697 12.695c0 .057.05.107.114.107h1.543a.116.116 0 0 0 .114-.107L13.868.871c0-.064-.05-.121-.114-.121"
          ></path>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_57_207">
          <path fill="#fff" d="M.91.75h22.75v17.096H.91z"></path>
        </clipPath>
      </defs>
    </svg>
  );
}
